import React from 'react';

import { AITool } from '@vyce/core/src/views/ai';

// User and company come from the AIChatContextProvider in views/main/Main.tsx.
export const EmployerAITool: React.FC = () => <AITool />;
